import { createSelector } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';
import type { TTastePathData } from '@lib/tools/tastePathProducts/types/types';

/**
 * Selects the entire taste path products state from the Redux store.
 */
const selectTastePath = (state: AppStateType) => state.tastePath;

/**
 * Selects the taste path data, containing product information for different taste path categories.
 */
export const selectTastePathData = createSelector([selectTastePath], state => state.tastePathData);

/**
 * Selects taste path data as an array (one item per category). Prefer this when iterating;
 * use selectTastePathData when you need access by category id.
 */
export const selectTastePathDataList = createSelector([selectTastePathData], (tastePathData): TTastePathData[] =>
  tastePathData ? Object.values(tastePathData) : [],
);

/**
 * Selects the loading state for taste path products.
 */
export const selectIsTastePathProductsLoading = createSelector(
  [selectTastePath],
  state => state.isTastePathProductsLoading,
);

/**
 * Selects the ID of the current taste path category.
 */
export const selectCurrentStyleCategoryId = createSelector([selectTastePath], state => state.currentStyleCategoryId);

/**
 * Selects the ID of the next taste path category.
 */
export const selectNextStyleCategoryId = createSelector([selectTastePath], state => state.nextStyleCategoryId);
